<template>
    <div class="p-4">
        <div class="text-14 lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 pb-2">
            <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.orderNoLabel }}</div>
                <div class="ml-auto mr-0">{{ trackingOrder.tranId }}</div>
            </div>
            <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.orderType }}</div>
                <div class="text-a-brown-502314">{{ getOrderType() }}</div>
            </div>
            <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.estimateTime }}</div>
                <div class="ml-auto mr-0">
                    <div v-if="trackingOrder.orderType === 'Subscription'">-</div>
                    <div v-else>{{ getCompleteDate(trackingOrder.expectDelivery) }}<span class="font-bold">{{getCompleteTime(trackingOrder.expectDelivery)}}</span></div>
                </div>
            </div>
            <!-- <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.status }}</div>
                <div class="ml-auto mr-0">{{ trackingOrder.vendorStatusName }}</div>
            </div> -->
        </div>
        <div class="text-14  lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 py-3 lg:py-4">
            <div class=" mb-4">{{ lbl.myOrder.orderSummary }}</div>
            <div v-if="firstOrderItem">
                <div class="flex items-start">
                    <div class="ml-0 mr-2 mt-1">
                        <div class="py-0.5 px-1 border border-a-brown-502314 rounded-5 font-bold">
                            {{ firstOrderItem.quantity }}x</div>
                    </div>
                    <div class="ml-0 mr-auto pr-1 campaign-name">{{ localeCode ==
                                1033 ? firstOrderItem.nameEN : firstOrderItem.name }}</div>
                    <div class="ml-auto mr-0">{{ firstOrderItem.pricePerUnit }} {{lbl.myOrder.bath}}</div>
                </div>
                <div class="ml-8 text-12 lg:text-14">
                    <p v-for="(other, otherIndex) in firstOrderItem.others" :key="`other-item-${otherIndex}`">
                        {{ other.Quantity }}x {{ localeCode == 1033 ? other.NameEN : other.Name }}
                    </p>
                    <div class="pt-3 text-12 lg:text-14" v-for="(addons, addonsIndex) in firstOrderItem.addons"
                        :key="`addons-${addonsIndex}`">
                        <p class="text-14 lg:text-16">{{ localeCode === 1033 ? addons.HeaderEN : addons.Header }}</p>
                        <p v-for="(addonItem, addonItemIndex) in addons.Items" :key="`addon-item-${addonItemIndex}`">
                            {{ addonItem.Quantity }}x {{ localeCode == 1033 ? addonItem.NameEN : addonItem.Name }} (+{{ addonItem.PricePerUnit }} {{lbl.myOrder.bath}})
                        </p>
                    </div>
                    <div class="pt-3" v-for="(appetizers, appetizersIndex) in firstOrderItem.appetizers"
                        :key="`appetizers-${appetizersIndex}`">
                        <p class="text-14">{{ localeCode === 1033 ? appetizers.HeaderEN : appetizers.Header }}</p>
                        <p v-for="(appetizersItem, appetizersItemIndex) in appetizers.Items" :key="`appetizers-item-${appetizersItemIndex}`">
                            {{ appetizersItem.Quantity }}x {{ localeCode == 1033 ? appetizersItem.NameEN : appetizersItem.Name }} (+{{ appetizersItem.PricePerUnit }} {{lbl.myOrder.bath}})
                        </p>
                    </div>
                </div>
            </div>

            <OrderItemList></OrderItemList>
        </div>
        <div class="text-14 lg:text-16 text-a-brown-502314 border-b border-a-brown-d7c7b8 py-2">
            <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.subTotal }}</div>
                <div class="ml-auto mr-0">{{ numberFormat(trackingOrder.campaignAmount) }} {{lbl.myOrder.bath}}</div>
            </div>
            <div class="flex pb-2" v-if="trackingOrder.orderType != 'InStore'">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.deliveryFee }}</div>
                <div class="ml-auto mr-0" v-if="trackingOrder.shippingAmount">{{ numberFormat(trackingOrder.shippingAmount) }} {{lbl.myOrder.bath}}</div>
                <div class="ml-auto mr-0" v-else>-</div>
            </div>
            <div class="flex pb-2">
                <div class="ml-0 mr-auto">{{ lbl.myOrder.discount }}</div>
                <div class="ml-auto mr-0" v-if="getDiscount() != 0">{{ numberFormat(getDiscount()) }} {{lbl.myOrder.bath}}</div>
                <div class="ml-auto mr-0" v-else>-</div>
            </div>
            <div class="flex pb-2 text-16 lg:text-18">
                <div class="ml-0 mr-auto font-bold">{{ lbl.myOrder.total }}</div>
                <div class="ml-auto mr-0 font-bold">{{ numberFormat(trackingOrder.tranAmount) }} {{lbl.myOrder.bath}}</div>
                
            </div>
        </div>
        <div class="text-14 lg:text-16 text-a-brown-502314 py-2">
            <div class="flex pb-2 ">
                <div class="ml-0 mr-auto font-bold text-16">{{ lbl.myOrder.paymentDetails }}</div>
                <div class="ml-auto mr-0" v-if="trackingOrder.channel == 'pod'">{{lbl.myOrder.cash}} </div>
                <div class="ml-auto mr-0" v-if="trackingOrder.channel == 'omise'">{{lbl.myOrder.credit}} </div>
                <div class="ml-auto mr-0 line-pay text-a-red-d62300" v-if="trackingOrder.channel == 'linepay'"><img class="inline-block mr-1" src="@/assets/shopping_cart/line-pay.png" />Rabbit LINE Pay</div>
                <div class="ml-auto mr-0" v-if="trackingOrder.channel == 'omise_truewallet'">{{lbl.myOrder.truewallet}}</div>
                <div class="ml-auto mr-0" v-if="trackingOrder.channel == 'omise_promptpay'">{{lbl.myOrder.promptpay}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, inject, ref } from 'vue'
import DatetimeHelper from '@/helper/DatetimeHelper'
import Utility from '@/helper/Utility'

// component
import OrderItemList from "./OrderItemList.vue"

export default {
    name: 'OrderDetail',
    components: {
        OrderItemList
    },
    setup: function () {
        const { lbl,localeCode } = inject("LocaleStore")
        const trackingOrder = inject("getTracking")
        const orderItems = inject("getOrderItems")
        const firstOrderItem = ref(null);

        const getCompleteDate = function (completeDate) {
            return DatetimeHelper.timestampFullFormat(completeDate) + " | ";
        }

        const getCompleteTime = function (completeDate) {
            return DatetimeHelper.timeFormatShort2(completeDate);
        }

        const numberFormat = function (v) {
            return Utility.formatNum(v)
        }

        const getOrderType = function () {
            if (trackingOrder.value.orderType == "InStore") {
                if (trackingOrder.value.orderPlan == "TakeOut") {
                    return lbl.value.myOrder.orderTypeText.takeaway;
                } else {
                    return lbl.value.myOrder.orderTypeText.dinein;
                }
            } else if (trackingOrder.value.orderType == "Subscription") {
                return lbl.value.myOrder.orderTypeText.subscription;
            } else {
                return lbl.value.myOrder.orderTypeText.delivery;
            }
        }

        const getPayment = function () {
            if (trackingOrder.value.channel == "omise") { 
                return lbl.value.myOrder.credit;
            } else if (trackingOrder.value.channel == "omise_truewallet") {
                return lbl.value.myOrder.truewallet;
            } else if (trackingOrder.value.channel == "omise_promptpay") {
                return lbl.value.myOrder.promptpay;
            } else if (trackingOrder.value.channel == "linepay") {
                return lbl.value.myOrder.linepay;
            } else {
                return lbl.value.myOrder.cash;
            }
        }

        const getDiscount = function () {
            let sumDiscount = 0;
            if (trackingOrder.value.discount) {
                sumDiscount += trackingOrder.value.discount;
            }

            if (trackingOrder.value.deliveryDiscount) {
                sumDiscount += trackingOrder.value.deliveryDiscount;
            }
            return sumDiscount;
        }

        firstOrderItem.value = orderItems.value[0]

        const deliveryFee = computed(() => {
            return Utility.formatNum(trackingOrder.value?.shippingAmount ?? 0)
        })

        return {
            lbl,
            localeCode,
            trackingOrder,
            getCompleteDate,
            getCompleteTime,
            getOrderType,
            getPayment,
            numberFormat,
            firstOrderItem,
            deliveryFee,
            getDiscount
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/text.scss";
    .campaign-name {
        width: calc(100% - 100px);
    }

    .line-pay {
        @extend %ellipsis-1;
        width: auto;
        @include mobile {
            width: 180px;
        }
    }
</style>
